import { render, staticRenderFns } from "./step6-payment.vue?vue&type=template&id=13f0e46e&scoped=true"
import script from "./step6-payment.vue?vue&type=script&lang=js"
export * from "./step6-payment.vue?vue&type=script&lang=js"
import style0 from "./step6-payment.vue?vue&type=style&index=0&id=13f0e46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0e46e",
  null
  
)

export default component.exports